import { render, staticRenderFns } from "./org.vue?vue&type=template&id=645dba1a&scoped=true"
import script from "./org.vue?vue&type=script&lang=js"
export * from "./org.vue?vue&type=script&lang=js"
import style0 from "./org.vue?vue&type=style&index=0&id=645dba1a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645dba1a",
  null
  
)

export default component.exports